export const INITIALIZE = 'INITIALIZE'
export const CLEAR_STATE = 'CLEAR_STATE'
export const FILE_VIEWER_SET = 'FILE_VIEWER_SET'
export const CHANGE_PROGRESS = 'CHANGE_PROGRESS'
export const CHANGE_DEV_MODE = 'CHANGE_DEV_MODE'
